import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Environment } from '../interfaces/environment.interface';
import { ENVIRONMENT } from '../tokens/environment.token';
import { USER_CONTEXT } from '../tokens/user-context.token';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
	const environment = inject<Environment>(ENVIRONMENT);
	const userStore = inject(USER_CONTEXT);

	const getAcceptHeader = (url: string): string => {
		if (url.includes(environment.serverNew)) {
			return 'application/vnd.api+json';
		}
		return 'application/json';
	};

	const getAcceptLanguageHeader = (url: string): string | null => {
		if (!url.includes(environment.serverNew)) {
			const currentUser = userStore.currentUser();
			if (currentUser?.lang) {
				return currentUser.lang;
			}
		}
		return null;
	};

	const acceptHeader = getAcceptHeader(req.url);
	const languageHeader = getAcceptLanguageHeader(req.url);

	const headers: Record<string, string> = {};

	if (acceptHeader === 'application/vnd.api+json' && !req.headers.has('Accept')) {
		headers['Accept'] = acceptHeader;
		headers['Content-Type'] = acceptHeader;
	}

	if (languageHeader) {
		headers['Accept-Language'] = languageHeader;
	}

	// If we have headers to set, clone the request
	const modifiedReq = Object.keys(headers).length ? req.clone({ setHeaders: headers }) : req;

	return next(modifiedReq);
};
